import { createSlice } from '@reduxjs/toolkit';
interface IPersonasState {
    listPersonas: any[];
    listValue: any[];
    isUpdate: Boolean;
}
const initialState: IPersonasState = {
    listPersonas: [],
    listValue: [],
    isUpdate: false,
};
// Action =====================================================
const personasSlice = createSlice({
    name: 'personas',
    initialState,
    reducers: {
        getListPersonas: (state, action) => {
            state.listPersonas = action.payload;
        },
        getListAnswerPersonas: (state, action) => {
            state.listValue = action.payload;
        },
        updateStatus: (state, action) => {
            state.isUpdate = action.payload;
        },
    },
});

// Selector =====================================================
export const { getListPersonas, getListAnswerPersonas, updateStatus } = personasSlice.actions;
// Reducer=====================================================
const personasReducer = personasSlice.reducer;
export default personasReducer;
